import { Col, Row } from 'antd';
import {
  CustomModal,
  CustomTable,
  CustomText,
} from '../../../../components';
import { ColumnsType } from 'antd/es/table';

interface IModalAdditions {
  isShow: boolean;
  handleModalAdditions?: (opc: boolean) => void;
  onSave: () => void;
  formik: any;
  additionSelected: any;
}
const ModalAdditions = ({
  isShow,
  handleModalAdditions,
  onSave,
  formik,
  additionSelected,
}: IModalAdditions) => {
  const columnsActivo: ColumnsType = [
    {
      title: 'Item',
      dataIndex: 'id',
      key: 'id',
      render: (item) => {
        return item ? item : '-';
      },
    },
    {
      title: 'Código/placa',
      dataIndex: 'plate_code',
      key: 'plate_code',
      render: (item) => {
        return item ? item : '-';
      },
    },
    {
      hidden: additionSelected.class ? true : false,
      title: 'Descripción',
      dataIndex: 'description',
      key: 'description',
      render: (item) => {
        return item ? item : '-';
      },
    },
    {
      hidden: additionSelected.class ? false : true,
      title: 'Descripción',
      dataIndex: 'asset',
      key: 'asset',
      render: (item) => {
        return item ? item : '-';
      },
    },
    {
      hidden: additionSelected.class ? true : false,
      title: 'Clase de activo',
      dataIndex: 'asset_class',
      key: 'asset_class',
      render: (item) => {
        return item && item.name ? `${item.code} - ${item.name}` : '-';
      },
    },
    {
      hidden: additionSelected.class ? false : true,
      title: 'Clase de activo',
      dataIndex: 'class',
      render: (item) => {
        return item && item.name ? `${item.code} - ${item.name}` : '-';
      },
    },
    {
      title: 'Artículo',
      dataIndex: 'item',
      key: 'item',
      render: (item) => {
        return item && item.name ? `${item.code} - ${item.name}` : '-';
      },
    },
    {
      title: 'Adiciones',
      dataIndex: 'assets',
      key: 'assets',
      render: (item) => {
        return item && item.length > 0 ? item.length : '-';
      },
    },
    {
      hidden: additionSelected.good_status ? false : true,
      title: 'Estado del bien',
      dataIndex: 'good_status',
      key: 'good_status',
      render: (item) => {
        return item && item.status ? item.status : '-';
      },
    },
    {
      hidden: additionSelected.good_status ? true : false,
      title: 'Estado del bien',
      dataIndex: 'asset_good_status',
      key: 'asset_good_status',
      render: (item) => {
        return item && item.status ? item.status : '-';
      },
    },
  ];
  const columnsAdiciones: ColumnsType = [
    {
      title: 'Item',
      dataIndex: 'id',
      key: 'id',
      render: (item) => {
        return item ? item : 'Sin registro';
      },
    },
    {
      title: 'Código/placa',
      dataIndex: 'plate_code',
      key: 'plate_code',
      render: (item) => (item ? item : 'Sin registro'),
    },
    {
      title: 'Descripción',
      dataIndex: 'description',
      key: 'description',
      render: (item) => (item ? item : 'Sin registro'),
    },
    {
      title: 'Clase de activo',
      dataIndex: 'asset_class',
      key: 'asset_class',
      render: (item) => {
        return item && item.name ? `${item.code} - ${item.name}` : 'Sin registro';
      },
    },
    {
      title: 'Artículo',
      dataIndex: 'item',
      key: 'item',
      render: (item) => {
        return item && item.name ? `${item.code} - ${item.name}` : 'Sin registro';
      },
    },
    {
      title: 'Estado del bien',
      dataIndex: 'good_status',
      key: 'good_status',
      render: (item) => (item && item.status ? item.status : 'Sin registro'),
    },
  ];
  return (
    <CustomModal
      centered
      open={isShow}
      title="Ver adiciones"
      onSave={onSave}
      labelCancel="Finalizar"
      onCancel={() => handleModalAdditions?.(false)}
      disabledBtn={!formik.isValid}
      width="95vw"
    >
      <Row gutter={[24, 24]} justify="start" style={{ marginBottom: '40px' }}>
        <CustomText text="Activo principal" strong={true} />
        <Col xs={24} sm={24} md={24} lg={24}>
          <CustomTable
            dataSource={[additionSelected]}
            columns={columnsActivo}
            scroll={{ x: 'max-content' }}
            pagination={false}
          />
        </Col>
      </Row>
      <Row gutter={[24, 24]} justify="start">
        <CustomText text="Adiciones" strong={true} />
        <Col xs={24} sm={24} md={24} lg={24}>
          <CustomTable
            dataSource={additionSelected.assets}
            columns={columnsAdiciones}
            scroll={{ x: 'max-content' }}
          />
        </Col>
      </Row>
    </CustomModal>
  );
};

export default ModalAdditions;
